<div id="side-navigation">
  <div class="container-fluid p-0">
    <div class="row g-0">

      <!-- Sidebar -->
      <div class="col-12 col-md-4 col-lg-3 side-menu">
        <h6>Best Practices</h6>

        <!-- Back Button -->
        <div>
          <a class="back-link" (click)="goBack($event)" style="cursor: pointer;">← Back</a>
        </div>


        <ul class="nav flex-column">
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/iqac/best-prac/building-stronger-communities-through-education">
              Building Stronger Communities Through Education
            </a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/iqac/best-prac/go-green-initiative">
              Go Green Initiative
            </a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/iqac/best-prac/yoga-meditation">
              Yoga and Meditation
            </a>
          </li>
        </ul>
      </div>

      <!-- Inner Content -->
      <div class="col-12 col-md-8 col-lg-9">
        <router-outlet></router-outlet>
      </div>

    </div>
  </div>
</div>